<template>
    <div v-if="client" class="recaptcha-container">
        <div
            v-if="recaptchaKey && client.general.useRecaptcha"
            ref="recaptcha"
            class="g-recaptcha"
            :data-sitekey="recaptchaKey"
            data-callback="onRecaptchaResponse"
            data-expired-callback="onRecaptchaError"
            data-error-callback="onRecaptchaError"
        ></div>
        <div
            v-if="loading || !client.general.useRecaptcha"
            class="has-text-grey-light has-text-weight-bold recaptcha-label"
        >reCAPTCHA</div>
    </div>
</template>

<script>
import Vue from 'vue';

export default {
    name: 'recaptcha',
    props: {
        onResponse: {
            type: Function,
            required: true
        }
    },
    data() {
        return {
            loading: true,
            recaptchaKey: null,
            recaptchaResponse: null
        };
    },
    computed: {
        client() {
            return Vue.state.client.get();
        },
        verified() {
            return this.recaptchaResponse || (this.client && this.client.general.useRecaptcha === false);
        }
    },
    async created() {
        await Vue.state.client.ensure();
        window.onRecaptchaResponse = resp => {
            this.onRecaptchaResponse(resp);
        };
        window.onRecaptchaError = err => {
            this.onRecaptchaError(err);
        };
        this.recaptchaKey = window && window.pahglobal && window.pahglobal.googleRecaptchaKey;
        this.waitRecaptcha();
    },
    methods: {
        waitRecaptcha() {
            var timer = setInterval(() => {
                if (window.pahglobal.recaptchaIsReady && this.client && typeof this.client.general.useRecaptcha === 'boolean') {
                    this.loading = false;
                    if (this.client.general.useRecaptcha) {
                        try {
                            grecaptcha.render(this.$refs.recaptcha);
                        } catch (e) {
                            console.error(e);
                        }
                    }
                    clearInterval(timer);
                }
            }, 100);
        },
        onRecaptchaResponse(response) {
            this.onResponse(response);
            this.recaptchaResponse = response;
        },
        async onRecaptchaError(err) {
            console.error('recaptcha error:');
            console.error(err);
            await Vue.router.teleport.home();
        }
    }
};
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/common/recaptcha/recaptcha.vue